const initialState = {};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_COMPANY_DETAILS":
      return {
        ...state,
        companyDetails: action.companyDetails,
      };
    case "UPDATE_EMPLOYEE_DETAILS":
      return {
        ...state,
        employeeDetails: action.employeeDetails,
      };
    case "UPDATE_PLUM_PRO_POINTS":
      return {
        ...state,
        plumProPoints: action.plumProPoints,
      };
    case "UPDATE_USER_BALANCE":
      return {
        ...state,
        userBalance: action.userBalance,
      };

    case "UPDATE_CLIENT_ID":
      return {
        ...state,
        clientId: action.clientId,
      };
    case "UPDATE_KYB_STATUS":
      return {
        ...state,
        kybStatus: action.kybStatus,
      };
    case "UPDATE_SHOW_CTS":
      return {
        ...state,
        showCts: action.showCts,
      };
    case "CHECK_FOR_ACTIVE_INTEGRATION":
      return {
        ...state,
        activeIntegration: action.activeIntegration,
      };
    case "CHECK_FOR_ALL_INTEGRATIONs":
      return {
        ...state,
        allIntegrations: action.allIntegrations,
      };

    case "CHECK_FOR_AWARD_MENU":
      return {
        ...state,
        awardCheck: action.awardCheck,
      };

    case "UPDATE_XOXO_POINTS":
      return {
        ...state,
        xoxoPoints: action.xoxoPoints,
      };
    case "UPDATE_MODULE_ACCESS_LIST":
      return {
        ...state,
        moduleAcl: action.moduleAcl,
      };
    case "UPDATE_USER_AND_COMPANY_TYPE":
      return {
        ...state,
        typeData: action.typeData,
      };
    case "UPDATE_CATALOG_LIST_DATA":
      return {
        ...state,
        catalogData: action.catalogData,
      };
    case "UPDATE_PLATFORM_SETTINGS":
      return {
        ...state,
        platformSettings: action.platformSettings,
      };
    case "UPDATE_DISTRIBUTION_TYPE":
      return {
        ...state,
        distributionType: action.distributionType,
      };
    default:
      return state;
  }
};

export default accountReducer;
